export const filterStateFormIds = (state, form) => {
  const selectedState = state.filter((_, index) => form[index].checked);
  return selectedState.map((selected) => selected.id);
};
